import {
    BrowserCacheLocation,
    Configuration,
    LogLevel,
    InteractionType
} from '@azure/msal-browser';
import { environment } from '../../../../environments/environment';

/**
 * Detects if browser is Internet Explorer
 */
const isIE =
    window.navigator.userAgent.indexOf('MSIE ') > -1 ||
    window.navigator.userAgent.indexOf('Trident/') > -1;

/**
 * MSAL Configuration
 * @see https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: environment.adConfig,
    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: isIE, // Set to true for IE 11
        secureCookies: environment.production,
    },
    system: {
        loggerOptions: {
            // MSAL log output is intentionally discarded so nothing is written to the browser console.
            loggerCallback: () => undefined,
            logLevel: LogLevel.Error,
            piiLoggingEnabled: false, //Controls whether MSAL logs Personally Identifiable Information (PII) in console logs.
        }
    },
};